import React, { useState, useEffect } from 'react';

const InvoiceViewItemList = ({ GrnItemData, currencyPrecision, isVatExcluded, setIsVatExcluded,
    setOverallDiscount, grandTotal, overallDiscount, setDiscountAmount, discountAmount, setGrandTotal, setVatAmount, vatAmount, }) => {
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        unitPrice: '',
        amount: '',
        discount: '',
        vat: '',
        vatAmount: '',
        grnAccountCode: '',
        grnAccountName: '',
        invoiceAccountCode: '',
        invoiceAccountName: '',
        cgsAccountCode: '',
        cgsAccountName: '',
        inventoryAccountCode: '',
        inventoryAccountName: '',
    }]);

    const calculatedTotal = rows.reduce((sum, row) => {
        const qty = parseFloat(row?.qty) || 0;
        const unitPrice = parseFloat(row?.unitPrice) || 0;
        let final = (unitPrice * qty)
        return sum + (final);
    }, 0);

    useEffect(() => {

        const total = rows.reduce(
            (sum, row) => sum + Number(row?.amount || 0),
            0
        );

        const vatAmount = rows.reduce(
            (sum, row) => sum + Number(row?.vatAmount || 0),
            0
        );
        debugger
        const discountAmt = (calculatedTotal * overallDiscount) / 100;
        let afterdiscount = (calculatedTotal - discountAmt)
        const grandtotals = (afterdiscount + vatAmount)
        const grandtotalsvat = (afterdiscount + vatAmount)
        let final = overallDiscount === 0 ? grandtotalsvat : grandtotals
        setDiscountAmount(discountAmt);
        setGrandTotal(final);
        setVatAmount(vatAmount)
    }, [rows, overallDiscount]);


    useEffect(() => {
        getItems();
    }, [GrnItemData]);

    const getItems = async () => {
        try {
            const filterered = GrnItemData?.filter((itm) => itm?.qty > 0)
            const formattedRowsitm = filterered?.map(async (detail, index) => {

                const amount = Number(detail?.qty || 0) * Number(detail?.unitPrice || 0);

                const discountPerc = Number(overallDiscount || 0);

                const discountAmount = (amount * discountPerc) / 100;

                const calculatedAmount = amount - discountAmount;

                const vatRate = Number(detail?.vatPerc || 0);

                const vatAmount = (calculatedAmount * vatRate) / 100;

                const totalAmount = calculatedAmount + vatAmount;
                return {
                    srno: detail?.srno,
                    grnNo: detail.grnNo,
                    ItemNo: detail.itemCode,
                    itemDescription: detail.itemDescription,
                    qty: detail.qty,
                    uom: detail.uom,
                    baseAmount: detail.price,
                    specification: detail.specification,
                    unitPrice: detail.unitPrice,
                    stock: detail?.convToInvUOM * detail.qty,
                    vat: detail.vatPerc,
                    discount: discountPerc,
                    discountAmount: Number(discountAmount).toFixed(currencyPrecision),
                    calculatedAmount: Number(calculatedAmount).toFixed(currencyPrecision),
                    vatAmount: Number(vatAmount).toFixed(currencyPrecision),
                    amount: Number(totalAmount).toFixed(currencyPrecision),
                };
            }).filter(row => row !== null);
            const formattedRows = await Promise.all(formattedRowsitm);
            if (formattedRows.length > 0) {
                setRows(formattedRows);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };


    return (
        <div className='table-container p-2 ' style={{ overflowX: 'auto', height: "auto" }}>
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Discount %</label>
                    <input
                        type="number"
                        className="form-Input w-100"
                        min="0"
                        max="100"
                        value={overallDiscount} disabled
                    />
                </div>
                <div className="d-flex justify-content-between col-3">
                    <div className="form-check center mt-2">
                        <input
                            style={{ width: '26px', height: '26px' }}
                            type="checkbox"
                            className="form-check-input"
                            checked={isVatExcluded} disabled
                        />
                        <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                    </div>
                </div>
            </div>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Qty</th>
                        <th>Packing UOM</th>
                        <th>Inventory Qty</th>
                        <th>Unit Price</th>
                        <th>VAT %</th>
                        <th>Extra Amount</th>
                        <th>VAT Amount</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(rows) && rows.map((row, index) => (
                        <tr key={index}>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={index + 1} style={{ width: "80px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.ItemNo} style={{ width: "120px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.itemDescription} style={{ width: "300px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.specification} style={{ width: "150px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.qty} style={{ width: "80px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "140px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock} style={{ width: "140px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.unitPrice || 0).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.vat + " %"} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={0} style={{ width: "140px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} style={{ width: "135px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.amount || 0).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                        </tr>
                    ))
                    }
                </tbody>
            </table>
            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">_</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">After Discount</div>
                    <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">+</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceViewItemList;